/* We cna use (need .htaccess to route correctly) */
// import createHistory from 'history/createBrowserHistory';
/* Or (legacy and compatible but use ugly '#' in url) */
import createHistory from 'history/createHashHistory';

import config from 'config';

// Create a and export history of your choosing (using a browser history in this case)
const history = createHistory(config.historyConfig);
export default history;


// WEBPACK FOOTER //
// ./stores/history.js